export const state = () => ({});

export const getters = {
  hasPermissions: (state, getters, rootState, rootGetters) => (permission) => {
    if (
      !rootState.auth ||
      !rootState.auth.user ||
      !rootState.auth.user.permissions
    )
      return false;
    if (rootState.auth.user.permissions.find((perm) => perm === "bender"))
      return true;
    for (const perm of rootState.auth.user.permissions) {
      if (permissionMatch(permission, perm)) return true;
    }
    return false;
  },
};

function permissionMatch(required, actual) {
  const subTree = permissionStringToTree(required);
  const tree = permissionStringToTree(actual);

  if (Object.keys(subTree).length === 0) return false;
  return treeContains(subTree, tree);
}

function treeContains(subTree, tree) {
  for (const key in subTree) {
    if (!(key in tree)) {
      return false;
    }
    return treeContains(subTree[key], tree[key]);
  }
  return true;
}

function permissionStringToTree(str) {
  const obj = {};
  const stack = [obj];
  let currentNode = obj;
  let key = "";

  for (let i = 0; i < str.length; i++) {
    const char = str[i];

    if (char === "(") {
      const newNode = {};
      currentNode[key] = newNode;
      stack.push(newNode);
      currentNode = newNode;
      key = "";
    } else if (char === ",") {
      if (key) {
        currentNode[key] = {};
        key = "";
      }
    } else if (char === ")") {
      if (key) {
        currentNode[key] = {};
        key = "";
      }
      stack.pop();
      currentNode = stack[stack.length - 1];
    } else {
      key += char;
    }
  }

  return obj;
}
